<template>
    <i class="icon-box" :class="['icon-'+type, status == 'disabled' && 'is-disabled']">
        <img class="icon"
        :style="styleObj"
        :src="icon"
        @mouseenter="onMouseenter"
        @mouseleave="onMouseleave"
        ref="icon"
        @click="onClick"
        >
    </i>

</template>

<script>
export default {
  name: "Icon",
  componentName:"Icon",
  props: {
    /*
        命名和状态？
        图标放入 images 文件夹中，命名方式默认为 icon_iconName.png 【如果不需要切换效果，可以只放入一张图片】
        图片可以设置不同状态  hover,active,disabled，不同状态命名方式为 icon_iconName_hover.png, icon_iconName_active.png, icon_iconName_disabled.png

        如何使用不同状态的图标？
        1. 当设置 switchable 为 true 时，根据鼠标移入移出事件切换 icon_iconName.png 和 icon_iconName_hover.png
        2. 传入 status 对应的值

        取值优先级？
        1. 优先根据 status 中的值显示图标
        2. 设置 switchable 为 true 时，根据鼠标移入移出事件切换 默认图片 和 hover状态 的图片
        3. switchable 为 false  时, 只显示 默认图片

        为何只切换 鼠标移入移出 时的效果，不切换 click 时的效果？
        因为 图片的切换都是用 js 加载的，不是用 css 背景图，所以不能用 ::active 伪类
        如果需要 click 时切换图片，需要设置 status 来显示不同的图片
    */
    type: {
      type: String,
      require: true
    },
    switchable:{ // 是否默认显示鼠标移入时的图标效果
        type: Boolean
        ,default: false
    },
    status:{ // default , hover ,active ,disabled
        type:String
        ,default:''
    },
    width: {
      type: Number
    },
    height: {
      type: Number
    },
  }
  ,computed:{
        iconUrl(){
            let {type} = this;
            if(this.type){
                let currIcon ={
                    default: require("./images/icon_" + type + '.png')
                }

                if(this.switchable){
                    currIcon.hover = require("./images/icon_" + type + '_hover.png');
                }

                if(this.status && !currIcon[this.status]){
                    currIcon[this.status] = require("./images/icon_" + this.type + '_' + this.status + '.png');
                }
                if(currIcon){
                    return currIcon;
                }else{
                    return false;
                }
            }else{
                return false;
            }
        }
        ,icon(){
            let {status,isHover,iconUrl} = this;

            if(iconUrl){
                return status ? iconUrl[status] : (isHover ? iconUrl.hover : iconUrl.default);
            }
        }
        ,styleObj(){
            let _style = {};
            Object.assign(_style,{ width: this.width + 'px',height: this.height + 'px'});
            Object.assign(_style,this.style);
            return _style;
        }
    }
    ,data(){
        return {
            isHover: false
        }
    }
    ,methods:{
        onMouseenter(){
            if(this.switchable){
                this.isHover = true;
            }
            this.$emit('mouseenter',this.type);
        }
        ,onMouseleave(){
            if(this.switchable){
                this.isHover = false;
            }
            this.$emit('mouseleave',this.type);
        }
        ,onClick(){
            this.$emit('click',this.type);
        }
    }

};
</script>

<style scoped lang="less">
    .icon-box{
        &.is-disabled{
            pointer-events: none;
            cursor: default;
            opacity: 0.6;
            cursor: not-allowed;
        }
        display:inline-block;
        height:100%;
        .icon{
            vertical-align: middle;
        }
        &:before{
            content:'';
            display:inline-block;
            vertical-align: middle;
            height:100%;
        }
    }

</style>




// WEBPACK FOOTER //
// components/Icon/Icon.vue